import { CSSProperties } from 'react';

import { MILLISECONDS_IN_MINUTE, MILLISECONDS_IN_SECOND } from '@/consts';

const OAUTH_REDIRECT_VALIDATION_TIME_MIN = 15;

export const OAUTH_REDIRECT_VALIDATION_TIME = MILLISECONDS_IN_MINUTE * OAUTH_REDIRECT_VALIDATION_TIME_MIN;

export const SIGN_OUT_REDIRECT_VALIDATION_TIME = MILLISECONDS_IN_MINUTE;

const JUST_LOGGED_IN_TIMEOUT_SECONDS = 10;

export const JUST_LOGGED_IN_TIMESTAMP_KEY = 'justLoggedInToRecipientPage';

export const JUST_LOGGED_IN_TIMEOUT_MS = JUST_LOGGED_IN_TIMEOUT_SECONDS * MILLISECONDS_IN_SECOND;

/** Session flag: phone OTP completed for this share link (open can succeed after email-only Cognito). */
export const phoneMfaCompletedSessionKey = (linkId: string) => `recipientPhoneMfaCompleted:${linkId}`;

export const isPhoneMfaCompletedForLink = (linkId: string): boolean => (
    !!linkId && sessionStorage.getItem(phoneMfaCompletedSessionKey(linkId)) === 'true'
);

export const markPhoneMfaCompletedForLink = (linkId: string): void => {
    if (!linkId) {
        return;
    }
    sessionStorage.setItem(phoneMfaCompletedSessionKey(linkId), 'true');
};

export const clearPhoneMfaCompletedForLink = (linkId: string): void => {
    if (!linkId) {
        return;
    }
    sessionStorage.removeItem(phoneMfaCompletedSessionKey(linkId));
};

export const MAIN_SPINNER_STYLE: CSSProperties = {
    position: 'fixed',
    top: '20vh',
};

export const errorsNameSpace = 'recipientPage.errors';
